import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ACCESS_TOKEN_KEY, CookieService, PageActionService, REFRESH_TOKEN_KEY, UtilityService } from "@collab/comp-library";
import { User } from 'oidc-client-ts';
import { map } from "rxjs/operators";
import { AuthService } from "./shared/services/auth.service";
import { BackendService } from "./shared/services/backend.services";
import { Router } from "@angular/router";
import { LandingPageService } from "./pages/landing-page/service/landing-page.service";
import { AuthenticationService } from "./pages/login/service/authentication.service";
import { ContactUsService } from "./shared/component/contact-us/service/contact-us.service";

@Component({
  selector: "app-home",
  template: `
    <!-- <div style="text-align:center">
      <h1 style="font-size: 30px; font-weight: 800">
        AVA Token Information
      </h1>
    </div>
    <div>
      <button (click)='onLogin()'>Login</button>
      <button (click)='onRenewToken()'>Renew Token</button>
      <button (click)='onLogout()'>Logout</button>
    </div>
    <pre>{{currentUserJson}}</pre>
    <div>
      <h2>Messages</h2>
      <ul>
        <li *ngFor='let msg of messages'>{{msg}}</li>
      </ul>
    </div> -->
  `,
  styles: [],
})
export class HomeComponent implements OnInit {
  constructor(public authService: AuthService,
    private cookieService: CookieService,
    private backendService: BackendService,
    private landingPageService: LandingPageService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private utilityService: UtilityService,
    private contactUsService: ContactUsService,
    public pageActionService: PageActionService) {
  }

  messages: string[] = [];
  get currentUserJson(): string {
    return JSON.stringify(this.currentUser, null, 2);
  }
  currentUser: User;
  public userDetails: any;
  public userRelatedProducts: any;

  ngOnInit(): void {
    this.authService.getUser().then(user => {
      this.currentUser = user;
      if (!!!this.currentUser) {
        this.onLogin();
      } else {
        this.router.navigate(["/landing-page/all-products"]);
        this.cookieService.setCookie(
          ACCESS_TOKEN_KEY,
          this.currentUser.access_token,
          30
        );
        this.cookieService.setCookie(
          REFRESH_TOKEN_KEY,
          this.currentUser.refresh_token,
          30
        );
        this.authenticationService.accessToken = this.currentUser.access_token
        this.authenticationService
          .getUserRoles()
          .subscribe((response: any) => {
            if (response && response.userRoleResponse && response.userRoleResponse.avaUserId) {
              this.pageActionService.pageActions = response.userRoleResponse.pageActions;
              this.landingPageService.setProductsList(response.productCardList);
            }

            this.landingPageService.getLandingPageUserDetails().subscribe((response) => {
              this.userDetails = response && response.userDetails;
              this.userRelatedProducts = response && response.products;
              this.utilityService.broadcastUserProfile(this.userDetails);
            });
          });
      }
    });
  }

  clearMessages() {
    while (this.messages.length) {
      this.messages.pop();
    }
  }
  addMessage(msg: string) {
    this.messages.push(msg);
  }
  addError(msg: string | any) {
    this.messages.push('Error: ' + msg && msg.message);
  }

  public onLogin() {
    this.authService.login().catch(err => {
      this.addError(err);
    })
    this.router.navigate(["/landing-page/all-products"]);

    this.authenticationService
      .getUserRoles()
      .subscribe((response: any) => {
        if (response && response.userRoleResponse && response.userRoleResponse.avaUserId) {
          this.pageActionService.pageActions = response.userRoleResponse.pageActions;
          this.landingPageService.setProductsList(response.productCardList);
        }
        this.landingPageService.getLandingPageUserDetails().subscribe((response) => {
          this.userDetails = response && response.userDetails;
          this.userRelatedProducts = response && response.products;
          this.utilityService.broadcastUserProfile(this.userDetails);
        });
      });
    this.clearMessages();
  }

  public onRenewToken() {
    this.clearMessages();
    this.authService.renewToken()
      .then(user => {
        this.currentUser = user;
        this.addMessage('Silent Renew Success');
      })
      .catch(err => this.addError(err));
  }

  public onLogout() {
    this.clearMessages();
    this.authService.logout().catch(err => this.addError(err));
  }

  public refresh(): void {
    console.warn('AppComponent.refresh');
    this.authService.getUser().then(user => {
      this.currentUser = user;

      if (user) {
        this.addMessage('User Logged In');
      } else {
        this.addMessage('User Not Logged In');
      }
    }).catch(err => this.addError(err));
  }
}
